/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../bank-accounts/bank_accounts';
import '../common/time';
import '../common/countries';
import '../common/currency_codes';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "deposits": {
        "nested": {
          "BankAccountGroup": {
            "fields": {
              "linkedBankAccount": {
                "type": "squareup.deposits.BankAccountInfo",
                "id": 1,
                "rule": "optional"
              },
              "pendingBankAccount": {
                "type": "squareup.deposits.BankAccountInfo",
                "id": 2,
                "rule": "optional"
              },
              "passwordRequiredToLink": {
                "type": "bool",
                "id": 3,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "recentlyFailedBankAccount": {
                "type": "squareup.deposits.BankAccountInfo",
                "id": 4,
                "rule": "optional"
              },
              "recentlyFailedVerificationBankAccount": {
                "type": "squareup.deposits.BankAccountInfo",
                "id": 5,
                "rule": "optional"
              },
              "merchantBankAccounts": {
                "type": "squareup.deposits.BankAccountInfo",
                "id": 6,
                "rule": "repeated"
              }
            }
          },
          "BankAccountInfo": {
            "fields": {
              "state": {
                "type": "squareup.deposits.BankAccountInfo.BankAccountState",
                "id": 1,
                "rule": "optional"
              },
              "bankName": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "type": {
                "type": "squareup.bank_accounts.BankAccountType",
                "id": 3,
                "rule": "optional"
              },
              "accountHolderName": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "accountNumberSuffix": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "verifiedBy": {
                "type": "squareup.common.time.DateTime",
                "id": 6,
                "rule": "optional"
              },
              "primaryInstitutionNumber": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              },
              "secondaryInstitutionNumber": {
                "type": "string",
                "id": 8,
                "rule": "optional"
              },
              "supportsInstantDeposit": {
                "type": "bool",
                "id": 9,
                "rule": "optional"
              },
              "gringottsToken": {
                "type": "string",
                "id": 10,
                "rule": "optional"
              },
              "token": {
                "type": "string",
                "id": 11,
                "rule": "optional"
              },
              "deduplicationToken": {
                "type": "string",
                "id": 12,
                "rule": "optional"
              },
              "accountRoutingFideliusToken": {
                "type": "string",
                "id": 13,
                "rule": "optional"
              },
              "createdAt": {
                "type": "squareup.common.time.DateTime",
                "id": 14,
                "rule": "optional"
              },
              "deletedAt": {
                "type": "squareup.common.time.DateTime",
                "id": 15,
                "rule": "optional"
              }
            },
            "nested": {
              "BankAccountState": {
                "values": {
                  "BANK_ACCOUNT_STATE_DO_NOT_USE": 0,
                  "AWAITING_2FA_CONFIRMATION": 1,
                  "VERIFICATION_IN_PROGRESS": 2,
                  "ACTIVE": 3,
                  "FAILED": 4,
                  "VERIFICATION_CANCELLED": 5,
                  "DISABLED": 6
                }
              }
            }
          },
          "BankAccountSpec": {
            "fields": {
              "accountNumber": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "countryCode": {
                "type": "squareup.common.countries.Country",
                "id": 2,
                "rule": "optional"
              },
              "currencyCode": {
                "type": "squareup.common.CurrencyCode",
                "id": 3,
                "rule": "optional"
              },
              "type": {
                "type": "squareup.bank_accounts.BankAccountType",
                "id": 4,
                "rule": "optional"
              },
              "accountHolderName": {
                "type": "string",
                "id": 5,
                "rule": "optional"
              },
              "primaryInstitutionNumber": {
                "type": "string",
                "id": 6,
                "rule": "optional"
              },
              "secondaryInstitutionNumber": {
                "type": "string",
                "id": 7,
                "rule": "optional"
              }
            }
          },
          "LocalizedStatusMessage": {
            "fields": {
              "title": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "description": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.deposits?.nested?.BankAccountGroup && !$root.nested?.squareup?.nested?.deposits?.nested?.BankAccountInfo && !$root.nested?.squareup?.nested?.deposits?.nested?.BankAccountInfo?.nested?.BankAccountState && !$root.nested?.squareup?.nested?.deposits?.nested?.BankAccountSpec && !$root.nested?.squareup?.nested?.deposits?.nested?.LocalizedStatusMessage) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE BankAccountGroup @ squareup/deposits/api.proto at 16:1
 */
export const BankAccountGroup = $root.lookupType('squareup.deposits.BankAccountGroup');
fixType(BankAccountGroup);
Builder.createAndAttachToType(BankAccountGroup);
/**
 * A simplified representation of a bank account for the use of web clients that also provides easy
 * conversion to the client-protos version of a BankAccount object for mobile clients.
 *
 * SOURCE BankAccountInfo @ squareup/deposits/api.proto at 51:1
 */
export const BankAccountInfo = $root.lookupType('squareup.deposits.BankAccountInfo');
fixType(BankAccountInfo, {
  state: {
    required: true
  },
  type: {
    required: true
  },
  accountHolderName: {
    notEmpty: true
  },
  accountNumberSuffix: {
    notEmpty: true
  },
  primaryInstitutionNumber: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BankAccountInfo);
/**
 * Simplified external representation of the bank account's current state.
 *
 * SOURCE BankAccountState @ squareup/deposits/api.proto at 53:3
 */
BankAccountInfo.BankAccountState = $root.lookupEnum('squareup.deposits.BankAccountInfo.BankAccountState').values;
/**
 * SOURCE BankAccountSpec @ squareup/deposits/api.proto at 155:1
 */
export const BankAccountSpec = $root.lookupType('squareup.deposits.BankAccountSpec');
fixType(BankAccountSpec, {
  accountNumber: {
    notEmpty: true
  },
  countryCode: {
    required: true
  },
  currencyCode: {
    required: true
  },
  type: {
    required: true
  },
  accountHolderName: {
    notEmpty: true
  },
  primaryInstitutionNumber: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(BankAccountSpec);
/**
 * SOURCE LocalizedStatusMessage @ squareup/deposits/api.proto at 206:1
 */
export const LocalizedStatusMessage = $root.lookupType('squareup.deposits.LocalizedStatusMessage');
fixType(LocalizedStatusMessage);
Builder.createAndAttachToType(LocalizedStatusMessage);